import { useEffect, useState } from 'react';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import InputAdornment from '@mui/material/InputAdornment';
import { useTheme } from '@mui/material/styles';
import {
  CardContent,
  Grid,
  TextField,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  // Tooltip,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Checkbox,
  Stack,
  Alert,
  AlertTitle,
} from '@mui/material';
import { OTHER_SERVICE_PROVIDERS } from '../shared/Constants';
import { getreferenceLabel } from './ascertain.util';
import styles from './styles';

const NBIKeepLandlineCollapseContent = ({
  radioValue,
  handleRadioChange,
  showContent,
  areacodes,
  setfixedlineUan,
  setLandlineno,
  setKeepNumberStateInError,
  setEnableNBISubmit,
  uanDetails,
}) => {
  const theme = useTheme();
  const [prefix, setPrefix] = useState();
  const [checked, setChecked] = useState(false);
  // const [enableCta, setEnableCTA] = useState(false);
  const [currentbbProvider, setCurrentbbProvider] = useState();
  // const [uanlabel, setuanLabel] = useState();
  // const [disableEditing, setdisableEditing] = useState(false);
  const [referenceNumberError, setReferenceNumberError] = useState(false);
  const [landlineNumberError, setLandlineNumberError] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState();
  const [landlineNumber, setLandlineNumber] = useState();
  const [refrenceData, setrefrenceData] = useState({
    referenceNumberLabel: '',
    referenceNumberAlertDescription: '',
    checkProvider: false,
  });
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
  };
  // const handleSubmit = async () => {
  //   let landline = '';
  //   if (prefix) {
  //     landline = `${prefix}-${landlineNumber}`;
  //   } else {
  //     landline = landlineNumber;
  //   }
  //   if (!referenceNumberError && !landlineNumberError && checked) {
  //     setCheckMark(true);
  //     setFixedLineCheckMark(true);
  //     setLandlineno(landline);
  //     setfixedlineUan(referenceNumber);
  //     setKeepNumberStateInError(true);
  //   }
  // };

  useEffect(() => {
    const prefixValue = Boolean(prefix);
    if (
      Boolean(referenceNumber) &&
      Boolean(landlineNumber) &&
      checked &&
      prefixValue &&
      !landlineNumberError &&
      !referenceNumberError
    ) {
      setEnableNBISubmit(true);
      let landline = '';
      if (prefix) {
        landline = `${prefix}-${landlineNumber}`;
      } else {
        landline = landlineNumber;
      }
      if (!referenceNumberError && !landlineNumberError && checked) {
        // setCheckMark(true);
        // setFixedLineCheckMark(true);
        setLandlineno(landline);
        setfixedlineUan(referenceNumber);
        setKeepNumberStateInError(true);
      }
    } else {
      setEnableNBISubmit(false);
    }
  }, [referenceNumber, landlineNumber, checked, prefix]);
  //   useEffect(() => {
  //     setPrefix(prefix);
  //     console.log('bbQAResult', bbQAResult);
  //     if (bbQAResult) {
  //       console.log('bbQAResult', bbQAResult);
  //       setdisableEditing(true);
  //       setReferenceNumber(bbQAResult?.accountNumber);
  //       setLandlineNumber(bbQAResult?.phoneNumber);
  //       setEnableCTA(true);
  //     }
  //   }, [bbQAResult]);

  useEffect(() => {
    if (uanDetails.provider === 'VIRGIN MEDIA') setReferenceNumber(uanDetails.number);
    const result = getreferenceLabel(uanDetails);
    setrefrenceData({
      ...refrenceData,
      referenceNumberLabel: result?.labelName,
      referenceNumberAlertDescription: result?.labelDescription,
      checkProvider: uanDetails.provider === 'VIRGIN MEDIA',
    });
  }, [showContent]);
  const handleUANChange = event => {
    if (event.target.id === 'referenceno') {
      const referenceNumberValue = event.target.value.replace(/[^A-Za-z0-9]/g, '');
      if (event.target.value.match(/^[A-Za-z]\d{10}$|^\d{10}$/)) {
        setReferenceNumberError(false);
      } else {
        setReferenceNumberError(true);
      }
      setReferenceNumber(referenceNumberValue);
    } else if (event.target.id === 'landlineno') {
      if (event.target.value.match(/^[0-9]{5,7}$/)) {
        setLandlineNumberError(false);
      } else {
        setLandlineNumberError(true);
      }
      setLandlineNumber(event.target.value);
    }
  };

  useEffect(() => {
    // if (currentbbProvider === OTHER_SERVICE_PROVIDERS.VIRGINMEDIA) {
    //   setuanLabel('Virgin Media Account Number');
    // } else if (currentbbProvider === OTHER_SERVICE_PROVIDERS.SKY) {
    //   setuanLabel('Sky Talk Account number');
    // } else {
    //   setuanLabel('Customer Reference / Account Number');
    // }
    const bbProvider = { provider: currentbbProvider };
    const result = getreferenceLabel(bbProvider);
    setrefrenceData({
      ...refrenceData,
      referenceNumberLabel: result?.labelName,
      referenceNumberAlertDescription: result?.labelDescription,
      checkProvider: uanDetails.provider === 'VIRGIN MEDIA',
    });
    // setUanDetails({ ...uanDetails, provider: currentbbProvider });
  }, [currentbbProvider]);
  const handleChange = event => {
    // checkEnablecta();
    setChecked(event.target.checked);
  };

  return (
    <CardContent sx={styles(theme).collapseContainer}>
      <Grid container>
        <Grid item xs={12}>
          <FormControl>
            <RadioGroup
              row
              name='yes-no'
              value={radioValue}
              onChange={handleRadioChange}
              sx={styles(theme).radioButton}
            >
              <FormControlLabel value='yes' control={<Radio />} label='Yes' />
              <FormControlLabel value='no' control={<Radio />} label='No' />
            </RadioGroup>
          </FormControl>
        </Grid>
        {showContent && (
          <>
            <Grid item xs={12} sm={6}>
              <Grid sx={styles(theme).inputContainer}>
                <FormControl
                  variant='outlined'
                  fullWidth
                  size='medium'
                  sx={styles(theme).inputTextbox}
                >
                  <InputLabel id='current-bb-label'>Current Broadband Provider*</InputLabel>
                  <Select
                    // sx={styles(theme).inputTextbox}
                    sx={{
                      '& .MuiSvgIcon-root': { color: theme.palette.primary.buttonColor },
                    }}
                    fullWidth
                    labelId='current-bb-label'
                    id='current-bb'
                    value={currentbbProvider}
                    label='Current Broadband Provider*'
                    onChange={e => setCurrentbbProvider(e.target.value)}
                  >
                    <MenuItem
                      value={OTHER_SERVICE_PROVIDERS.DIGIWEB}
                      sx={{ color: theme.palette.primary.textColor3 }}
                    >
                      {OTHER_SERVICE_PROVIDERS.DIGIWEB}
                    </MenuItem>
                    <MenuItem
                      value={OTHER_SERVICE_PROVIDERS.IFA}
                      sx={{ color: theme.palette.primary.textColor3 }}
                    >
                      {OTHER_SERVICE_PROVIDERS.IFA}
                    </MenuItem>
                    <MenuItem
                      value={OTHER_SERVICE_PROVIDERS.IMAGINE}
                      sx={{ color: theme.palette.primary.textColor3 }}
                    >
                      {OTHER_SERVICE_PROVIDERS.IMAGINE}
                    </MenuItem>

                    <MenuItem
                      value={OTHER_SERVICE_PROVIDERS.PURE}
                      sx={{ color: theme.palette.primary.textColor3 }}
                    >
                      {OTHER_SERVICE_PROVIDERS.PURE}
                    </MenuItem>
                    <MenuItem
                      value={OTHER_SERVICE_PROVIDERS.SKY}
                      sx={{ color: theme.palette.primary.textColor3 }}
                    >
                      {OTHER_SERVICE_PROVIDERS.SKY}
                    </MenuItem>
                    <MenuItem
                      value={OTHER_SERVICE_PROVIDERS.VIRGINMEDIA}
                      sx={{ color: theme.palette.primary.textColor3 }}
                    >
                      {OTHER_SERVICE_PROVIDERS.VIRGINMEDIA}
                    </MenuItem>
                    <MenuItem
                      value={OTHER_SERVICE_PROVIDERS.VODAFONE}
                      sx={{ color: theme.palette.primary.textColor3 }}
                    >
                      {OTHER_SERVICE_PROVIDERS.VODAFONE}
                    </MenuItem>
                    <MenuItem value='OTHER' sx={{ color: theme.palette.primary.textColor3 }}>
                      OTHER
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container item xs={12} sm={6}>
              <Grid item xs={12} sm={10} sx={!currentbbProvider ? { opacity: 0.4 } : ''}>
                <TextField
                  fullWidth
                  label={
                    refrenceData?.referenceNumberLabel || 'Customer Reference / Account Number'
                  }
                  // label={uanlabel}
                  id='referenceno'
                  disabled={!currentbbProvider}
                  onChange={handleUANChange}
                  value={referenceNumber}
                  required
                  sx={styles(theme).inputTextbox}
                  {...(referenceNumber ? { defaultValue: referenceNumber } : {})}
                  inputProps={{
                    style: { color: theme.palette.primary.textColor3 },
                    maxLength: uanDetails.provider === 'SKY' ? 11 : 10,
                    // endAdornment: (
                    //   <InputAdornment position='end'>
                    //     {' '}
                    //     <Tooltip
                    //       title='Reference number must contain only numbers'
                    //       enterDelay={200}
                    //       leaveDelay={800}
                    //       enterTouchDelay={0}
                    //     >
                    //       <InfoOutlinedIcon sx={{ color: 'rgba(50, 52, 53, 0.54)' }} />
                    //     </Tooltip>
                    //   </InputAdornment>
                    // ),
                  }}
                />

                {referenceNumberError && (
                  <Typography variant='body2' sx={styles(theme).errorMessage}>
                    {uanDetails.provider === 'SKY'
                      ? 'Reference number must be 11 digits long and can contain letters and numbers'
                      : 'Reference number must be 10 digits long and can contain only numbers'}
                  </Typography>
                )}
              </Grid>
            </Grid>
            {/* {showContent && currentbbProvider && (
              <Grid xs={12} sm={11} sx={styles(theme).NBIAlert}>
                <Alert
                  severity='info'
                  sx={{
                    padding: '0 16px',
                    backgroundColor: theme.palette.primary.backgroundColor6,
                  }}
                >
                  <AlertTitle sx={styles(theme).NBIAlertTitle}>
                    Your {uanlabel} can be found on your bill and may be a 10 digit number or begin
                    with PO.
                  </AlertTitle>
                </Alert>
              </Grid>
            )} */}
            {showContent &&
              currentbbProvider &&
              refrenceData?.referenceNumberAlertDescription !== '' && (
                <Grid xs={12} sm={11} sx={styles(theme).NBIAlert}>
                  <Alert
                    severity='info'
                    sx={{
                      padding: '0 16px',
                      backgroundColor: theme.palette.primary.backgroundColor6,
                    }}
                  >
                    <AlertTitle sx={styles(theme).NBIAlertTitle}>
                      {refrenceData.referenceNumberAlertDescription}
                    </AlertTitle>
                  </Alert>
                </Grid>
              )}
            <Grid container item xs={12} sm={5.7} sx={styles(theme).nbiLandlinePrefix}>
              <>
                <Grid xs={3} sm={3} sx={{ marginRight: '20px' }}>
                  <FormControl required fullWidth sx={styles(theme).inputTextbox}>
                    <InputLabel id='prefix-label' sx={{ color: theme.palette.primary.buttonColor }}>
                      Prefix
                    </InputLabel>
                    <Select
                      labelId='Prefix'
                      id='Prefix'
                      value={prefix}
                      label='Prefix'
                      MenuProps={MenuProps}
                      sx={{
                        '& .MuiSvgIcon-root': { color: theme.palette.primary.buttonColor },
                      }}
                      onChange={e => setPrefix(e.target.value)}
                    >
                      {areacodes?.map(areacode => (
                        <MenuItem
                          value={areacode.AREA_CODE}
                          onChange={e => setPrefix(e.target.value)}
                          sx={{
                            '& .MuiSvgIcon-root': { color: theme.palette.primary.buttonColor },
                            color: theme.palette.primary.textColor3,
                          }}
                        >
                          {areacode.AREA_CODE}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid xs={8.6} sm={8.1}>
                  <TextField
                    fullWidth
                    label='Landline number'
                    id='landlineno'
                    onChange={handleUANChange}
                    required
                    sx={styles(theme).inputTextbox}
                    {...(landlineNumber ? { defaultValue: landlineNumber } : {})}
                    inputProps={{
                      maxLength: 7,
                      style: { color: theme.palette.primary.textColor3 },
                    }}
                  />
                  {landlineNumberError && (
                    <Typography variant='body2' sx={styles(theme).errorMessage}>
                      Phone number must be between 5 and 7 digits
                    </Typography>
                  )}
                </Grid>
              </>
            </Grid>

            {showContent && (
              <Grid xs={12} sm={11} sx={styles(theme).NBIAlert}>
                <Alert
                  severity='info'
                  sx={{
                    padding: '0 16px',
                    backgroundColor: theme.palette.primary.backgroundColor6,
                  }}
                >
                  <AlertTitle sx={styles(theme).NBIAlertTitle}>
                    <strong>Important:</strong> Please enter the correct landline number you want to
                    move, otherwise you may lose your number.
                  </AlertTitle>
                </Alert>
              </Grid>
            )}
            <Grid container item xs={12}>
              <Box sx={{ marginTop: 2 }}>
                <Stack
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='flex-start'
                  spacing={0}
                >
                  <Typography
                    variant='body1'
                    sx={{
                      color: theme.palette.primary.textColor3,
                      pl: 0,
                      pr: 1,
                      pt: 1,
                      pb: 1,
                    }}
                  >
                    Our home phone service works through your broadband modem, not via a separate
                    landline. This means it requires a power supply. If you have a monitored alarm
                    or panic alarm that requires a connection to a landline, this will not work with
                    this phone service.
                  </Typography>
                </Stack>
              </Box>
            </Grid>
            <Grid container item xs={12}>
              <Checkbox
                name='termsAndCondition'
                id='termsAndCondition'
                sx={{
                  color: theme.palette.primary.textColor3,
                  '&.Mui-checked': {
                    color: theme.palette.primary.buttonColor,
                  },
                  pt: 0,
                  pl: 0,
                }}
                checked={checked}
                onClick={handleChange}
              />
              <span style={{ color: theme.palette.primary.textColor3 }}>I accept the above</span>
            </Grid>
            {/* <Grid container direction='row' justifyContent='center'>
              <Button
                variant='buttonMedium'
                onClick={handleSubmit}
                sx={enableCta ? styles(theme).enableSubmitCTA : styles(theme).disableSubmitCTA}
              >
                Next
              </Button>
            </Grid> */}
          </>
        )}
      </Grid>
    </CardContent>
  );
};

export default NBIKeepLandlineCollapseContent;
